export default {
    getCourseClusters: { method: 'get', url: 'course_clusters' },
    postCourseCluster: { method: 'post', url: 'course_clusters' },
    putCourseCluster: { method: 'put', url: 'course_clusters/{id}' },
    deleteCourseCluster: { method: 'delete', url: 'course_clusters/{id}' },
}